// extracted by mini-css-extract-plugin
export default {"DateNavigator":"DateNavigator_DateNavigator__cXb2h"};